<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ShiftPresetPanel from '../../../../../shift_presets/components/panels/ShiftPresetPanel.vue'

import { Site } from '../../../../../sites/models/site.ts'

definePage({
  props: true,
  meta: {
    requiresAuth: true,
    requiresOrganisation: true,
    hideLeftColumn: true,
    hideRightColumn: true,
  },
})

const { site } = defineProps<{
  site: Site
}>()
</script>

<template>
  <ShiftPresetPanel :site-id="site.id" />
</template>
